<template>
  <div>
    <el-table ref="table" :data="getList" border style="width: 100%">
      <!-- <el-table-column type="index" width="50" label="序号"> </el-table-column> -->
      <el-table-column prop="id" width="50" label="ID"> </el-table-column>
      <el-table-column width="80" prop="type" label="类别"> </el-table-column>
      <el-table-column show-overflow-tooltip width="110" prop="name" label="会员类型名称">
        <template slot-scope="scope">
          <span class="overflow-ellipsis" slot="reference">{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column width="80" prop="level" label="会员等级"> </el-table-column>
      <el-table-column width="80" prop="weightLevel" label="权重等级"> </el-table-column>
      <el-table-column width="100" prop="icon" label="会员图标">
        <template slot-scope="scope">
          <el-image v-if="scope.row.icon" :src="scope.row.icon" fit="scale - down"></el-image>
          <span v-else>未上传会员图标</span>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip width="120" prop="description" label="会员描述">
        <template slot-scope="scope">
          <span v-if="!scope.row.description">暂无描述</span>
          <span v-else class="overflow-ellipsis" slot="reference">{{ scope.row.description }}</span>
        </template>
      </el-table-column>
      <el-table-column width="110" prop="publishPrice" label="单日刊例价格"> </el-table-column>
      <el-table-column width="120" prop="clientTypes" label="客户端类型">
        <template slot-scope="scope">
          <el-tag style="margin-right: 5px;margin-bottom: 5px;" v-for="item in scope.row.clientTypes.split(',')"
            :key="item" size="small">{{ item }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column width="150" prop="rightsItemsDesc" label="权益项集">
        <template slot-scope="scope">
          <el-tag style="margin-right: 5px;margin-bottom: 5px;" v-for="item in scope.row.rightsItemsDesc.split(',')"
            :key="item" size="small">{{ item }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column width="80" prop="memberIdentity" label="用户身份"> </el-table-column>
      <el-table-column width="50" prop="state" label="状态"> </el-table-column>
      <el-table-column width="80" prop="sellStatus" label="售卖状态">
        <template slot-scope="scope">
        {{ scope.row.sellStatus === 1 ? '在售' : '停售' }}
        </template>
      </el-table-column>
      <el-table-column width="80" v-if="getCurrentTab === 'localData'" prop="reviewStatus" label="审核状态">
      </el-table-column>
      <el-table-column show-overflow-tooltip width="100" prop="remark" label="备注">
        <template slot-scope="scope">
          <span v-if="!scope.row.remark">暂无备注</span>
          <!-- <el-popover v-else placement="top" trigger="hover" :content="scope.row.remark"> -->
          <div v-else class="overflow-ellipsis" slot="reference">{{ scope.row.remark }}</div>
          <!-- </el-popover> -->
        </template>
      </el-table-column>
      <el-table-column width="130" fixed="right" v-if="getCurrentTab === 'localData'" label="操作">
        <template slot-scope="scope">
          <!-- 查看日志 -->
          <el-button v-auth="'MEMBER_TYPE_MANAGE_LOG'" type="text" size="small"
            @click="checkLog(scope.row.id)">查看日志</el-button>
          <el-button v-auth="'MEMBER_TYPE_MANAGE_EDIT'" v-if="scope.row.reviewStatus !== '待审核'" type="text" size="small"
            @click="handleEdit(scope.row)">编辑</el-button>
          <!-- 审核+提交审核+撤销审核 -->
          <!-- <el-button v-auth="'MEMBER_TYPE_MANAGE_AUDIT'" v-if="scope.row.reviewStatus === '待审核'" type="text" size="small"
            @click="handleAudit(scope.row)">审核</el-button> -->
          <el-button v-auth="'MEMBER_TYPE_MANAGE_FOR_AUDIT'" v-if="scope.row.reviewStatus === '草稿'" type="text"
            size="small" @click="handleSubmitAudit(scope.row)">提交审核</el-button>
          <el-button v-auth="'MEMBER_TYPE_MANAGE_CANCEL_AUDIT'" v-if="scope.row.reviewStatus === '待审核'" type="text"
            size="small" @click="handleCancelAudit(scope.row.id)">撤销审核</el-button>
          <!-- 删除 -->
          <el-button v-auth="'MEMBER_TYPE_MANAGE_DEL'" v-if="scope.row.reviewStatus !== '待审核'" type="text" size="small"
            @click="handleDel(scope.row.id)">删除</el-button>

        </template>
      </el-table-column>
    </el-table>
    <!-- //^ ^--------------编辑对话框-------------^ ^ -->
    <AddDialog :addDialog.sync="editDialog" title="编辑会员类型" :addFrom="addFrom" :TableClientSelect.sync="clientSelect"
      :memberTypeRightsItems.sync="memberTypeRightsItems" @updateData="updateData"></AddDialog>
    <!-- //^ ^-------------查看日志对话框--------------^ ^ -->
    <logDialog :logDialog.sync="logDialog" :id.sync="logId" :source.sync="source"></logDialog>
    <!-- //^ ^--------------审核对话框-------------^ ^ -->
    <AuditDialog :auditDialog.sync="auditDialog" :afterUpdate.sync="afterUpdate" :beforeUpdate.sync="beforeUpdate"
      :showAuditOpinion.sync="showAuditOpinion" @updateData="updateData"></AuditDialog>
  </div>
</template>

<script>
import AddDialog from './memberTypeAddDialog.vue';
import logDialog from './memberRightLog.vue';
import Message from "@/components/Message";
import AuditDialog from './memberTypeAuditDialog.vue';
import {
  getMemberTypeLocalDetail, getMemberRightLocalLimitParams,
  getAuditSnapshot, getMemberType, getUserIdentity,
  getMemberRightLocalList, cancelAudit,
  deleteMemberTypeLocal
} from "@/api/memberNew/memberType";
export default {
  name: 'WebSassMemberTypeTable',
  components: {
    AddDialog,
    logDialog,
    AuditDialog
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    currentTab: {
      type: String,
      default: '',
    },
  },
  computed: {
    getList() {
      return this.list;
    },
    getCurrentTab() {
      return this.currentTab;
    },
  },

  data() {
    return {
      /** 字典客户端类型 */
      dictClient: '',
      /** 字典展示场景 */
      dicDisplayScene: {
        '1': { '1': '小屏会员' },
        '2': { '1': '免广告会员', '2': '企业会员' },
        '3': { '1': '大屏会员' },
        '4': { '1': '影视会员' },
        '5': { '1': '企业会员' },
      },
      /** 字典会员身份 */
      dicMemberIdentity: '',
      /** 字典会员类别 */
      type: '',
      /** 修改前的审核数据 */
      beforeUpdate: {},
      /** 修改后的审核数据 */
      afterUpdate: {},
      /** 日志的来源 */
      source: '2',
      /** 日志的id */
      logId: "",
      /** 全局的限制参数 */
      limitParams: '',
      /** 回填的数据 */
      addFrom: '',
      /** 编辑对话框的显隐 */
      editDialog: false,
      /** 查看日志对话框的显隐 */
      logDialog: false,
      /** 审核对话框的显隐 */
      auditDialog: false,
      /** 回填客户端类型 */
      clientSelect: [],
      /** 回填权益项集合 */
      memberTypeRightsItems: [],
    };
  },
  created() {
    /** 获取字典限制参数备注 */
    this.getRemark()
    /** 获取字典会员类别 */
    this.getMemberType()
    /** 获取字典的用户身份 */
    this.getUserIdentity()
    /** 获取字典里的客户端类型 */
    this.getDictClient()
  },
  methods: {
    /** 编辑点击事件 */
    async handleEdit(row) {
      /** 调用获取详情的接口 */
      const { data } = await getMemberTypeLocalDetail(row.id);
      console.log('获取详情的接口', data.data);
      this.editDialog = true;
      /** 处理好客户端数据的回填 */
      const result = Object.entries(data.data.clientTypesMap).flatMap(([key, values]) =>
        values.map(value => [key, value])
      );
      this.clientSelect = result
      console.log('row', row);
      this.addFrom = {
        ...data.data,
        sellStatus: data.data.saleStatus,
        weightLevel: data.data.weight,
        clientTypes: '-',
        clientSelect: '-',
        memberTypeRightsItems: '-',
        sellVipType: []
      };
    },
    /** 通知父组件 */
    updateData() {
      this.$emit('updateData');
    },
    /** 查看日志事件 */
    checkLog(id) {
      console.log(this.logDialog);
      /** 把id传过去 */
      this.logId = id;
      this.logDialog = true;
      console.log(this.logDialog);
    },
    /** 提交审核 */
    async handleSubmitAudit(row) {
      console.log("提交审核传递过来的数据", row);
      /** 调用接口 */
      const { data } = await getAuditSnapshot(row.id);
      console.log("获取修改前后的数据响应", data.data);
      /** 如果修改前有数据 */
      console.log(this.type, data.data.online.type);
      
      try {
           /** 构建一个新对象 */
          if(data.data.online.id){
            const beforeObj = {
          id: data.data.online.id,
          type: this.type.find(item => item.value === (data.data.online.type)).label,
          level: data.data.online.level + '级',
          weightLevel: data.data.online.weight,
          sellStatus: data.data.online.saleStatus === 1 ? '在售' : '停售',
          memberIdentity: this.dicMemberIdentity.find(item => item.value === (data.data.online.memberIdentity)).label,
          name: data.data.online.name,
          icon: data.data.online.icon,
          description: data.data.online.description ? data.data.online.description : '暂无描述',
          publishPrice: data.data.online.publishPrice.toFixed(2) + '元',
          /** 客户端类型 */
          clientTypes: this.dictClient.map(item => {
            const clientTypes = data.data.online.clientTypesMap[item.code] || [];
            const clientTypeDescs = item.level2Dict
              .filter(dictItem => clientTypes.includes(dictItem.code))
              .map(dictItem => dictItem.desc);
            // 判断是否存在匹配的clientTypes
            if (clientTypeDescs.length > 0) {
              return `${item.desc}-${clientTypeDescs.join(', ')}`;
            } else {
              return null; // 没有匹配项时返回null
            }
            // 过滤掉为null的项,
          }).filter(item => item !== null),
          /** 权益项集 */
          memberRights: data.data.online.limitParamVals.map((item) => {
            return item.rightsName
          }),
          /** 限制参数 */
          limitParams: data.data.online.limitParamVals,
          state: data.data.online.state === '0' ? '禁用' : '启用',
          remark: data.data.online.remark ? data.data.online.remark : '暂无备注',
        } 
        if(data.data.online.type !== '0'){
          console.log(this.dicDisplayScene[data.data.online.type][data.data.online.sceneFlag],data.data.online.type, data.data.online.sceneFlag, 'this.dicDisplayScene[data.data.online.type][data.data.online.sceneFlag]');
          beforeObj.sceneFlag = this.dicDisplayScene[data.data.online.type][data.data.online.sceneFlag]
        }else {
          beforeObj.sceneFlag = ''
        }
        this.beforeUpdate = beforeObj;
      }else {
        this.beforeUpdate = {}
      }
        
        /** 构建一个新对象 */
        const afterObj = {
        id: data.data.local.id,
        type: this.type.find(item => item.value === (data.data.local.type)).label,
        level: data.data.local.level + '级',
        weightLevel: data.data.local.weight,
        sellStatus: data.data.local.saleStatus === 1 ? '在售' : '停售',
        memberIdentity: this.dicMemberIdentity.find(item => item.value === (data.data.local.memberIdentity)).label,
        name: data.data.local.name,
        icon: data.data.local.icon,
        description: data.data.local.description ? data.data.local.description : '暂无描述',
        publishPrice: data.data.local.publishPrice.toFixed(2) + '元',
        /** 客户端类型 */
        clientTypes: this.dictClient.map(item => {
          const clientTypes = data.data.local.clientTypesMap[item.code] || [];
          const clientTypeDescs = item.level2Dict
            .filter(dictItem => clientTypes.includes(dictItem.code))
            .map(dictItem => dictItem.desc);
          // 判断是否存在匹配的clientTypes
          if (clientTypeDescs.length > 0) {
            return `${item.desc}-${clientTypeDescs.join(', ')}`;
          } else {
            return null; // 没有匹配项时返回null
          }
          // 过滤掉为null的项,
        }).filter(item => item !== null),
        /** 权益项集 */
        memberRights: data.data.local.limitParamVals.map((item) => {
          return item.rightsName
        }),
        /** 限制参数 */
        limitParams: data.data.local.limitParamVals,
        state: data.data.local.state === '0' ? '禁用' : '启用',
        remark: data.data.local.remark ? data.data.local.remark : '暂无备注',
      };
        if(data.data.local.type !== '0'){
          afterObj.sceneFlag = this.dicDisplayScene[data.data.local.type][data.data.local.sceneFlag]
        }else {
          afterObj.sceneFlag = ''
        }
       this.afterUpdate = afterObj;
        } catch (error) {
          console.log(error);
        }
       
     

      // this.beforeUpdate = beforeObj;
      console.log("修改前的数据", this.beforeUpdate);
      console.log("修改后的数据", this.afterUpdate);

      this.auditDialog = true;
    },
    /** 撤销审核事件 */
    handleCancelAudit(id) {
      console.log("传递撤销审核的数据", id);
      /** 二次询问 */
      this.$confirm("是否确认撤销审核?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          /** 调用接口 */
          const { data } = await cancelAudit(id);
          console.log("撤销审核接口的响应", data);
          /** 如果成功提示用户 */
          if (data.code === 200) {
            Message.success("撤销审核成功");
            /** 更新数据 */
            this.$emit("updateData");
          } else {
            Message.error("撤销审核失败");
          }
        })
        .catch(() => {
          /** 更新数据 */
          this.$emit("updateData");
          // Message.info("已取消撤销审核");
        });
    },
    /** 审核事件 */
    async handleAudit(row) {
      /** 调用接口 */
      const { data } = await getAuditSnapshot(row.id);
      console.log("获取修改前后的数据响应", data.data);
      /** 如果修改前有数据 */
      if (data.data.online.id) {
        try {
           /** 构建一个新对象 */
        const beforeObj = {
          id: data.data.online.id,
          type: this.type.find(item => item.value === (data.data.online.type)).label || '',
          level: data.data.online.level + '级',
          weightLevel: data.data.online.weight,
          sellStatus: data.data.online.saleStatus === 1 ? '在售' : '停售',
          memberIdentity: this.dicMemberIdentity.find(item => item.value === (data.data.online.memberIdentity)).label,
          name: data.data.online.name,
          
          icon: data.data.online.icon,
          description: data.data.online.description ? data.data.online.description : '暂无描述',
          publishPrice: data.data.online.publishPrice.toFixed(2) + '元',
          /** 客户端类型 */
          clientTypes: this.dictClient.map(item => {
            const clientTypes = data.data.online.clientTypesMap[item.code] || [];
            const clientTypeDescs = item.level2Dict
              .filter(dictItem => clientTypes.includes(dictItem.code))
              .map(dictItem => dictItem.desc);
            // 判断是否存在匹配的clientTypes
            if (clientTypeDescs.length > 0) {
              return `${item.desc}-${clientTypeDescs.join(', ')}`;
            } else {
              return null; // 没有匹配项时返回null
            }
            // 过滤掉为null的项,
          }).filter(item => item !== null),
          /** 权益项集 */
          memberRights: data.data.online.limitParamVals.map((item) => {
            return item.rightsName
          }),
          /** 限制参数 */
          limitParams: data.data.online.limitParamVals,
          state: data.data.online.state === '0' ? '禁用' : '启用',
          remark: data.data.online.remark ? data.data.online.remark : '暂无备注',
        };
        if(data.data.online.type !== '0'){
          beforeObj.sceneFlag = this.dicDisplayScene[data.data.online.type][data.data.online.sceneFlag]
        }else {
          beforeObj.sceneFlag = ''
        }
        this.beforeUpdate = beforeObj;


         /** 构建一个新对象 */
      const afterObj = {
        id: data.data.local.id,
        type: this.type.find(item => item.value === (data.data.local.type)).label,
        level: data.data.local.level + '级',
        weightLevel: data.data.local.weight,
        sellStatus: data.data.local.saleStatus === 1 ? '在售' : '停售',
        memberIdentity: this.dicMemberIdentity.find(item => item.value === (data.data.local.memberIdentity)).label,
        name: data.data.local.name,
        icon: data.data.local.icon,
        description: data.data.local.description ? data.data.local.description : '暂无描述',
        publishPrice: data.data.local.publishPrice.toFixed(2) + '元',
        /** 客户端类型 */
        clientTypes: this.dictClient.map(item => {
          const clientTypes = data.data.local.clientTypesMap[item.code] || [];
          const clientTypeDescs = item.level2Dict
            .filter(dictItem => clientTypes.includes(dictItem.code))
            .map(dictItem => dictItem.desc);
          // 判断是否存在匹配的clientTypes
          if (clientTypeDescs.length > 0) {
            return `${item.desc}-${clientTypeDescs.join(', ')}`;
          } else {
            return null; // 没有匹配项时返回null
          }
          // 过滤掉为null的项,
        }).filter(item => item !== null),
        /** 权益项集 */
        memberRights: data.data.local.limitParamVals.map((item) => {
          return item.rightsName
        }),
        /** 限制参数 */
        limitParams: data.data.local.limitParamVals,
        state: data.data.local.state === '0' ? '禁用' : '启用',
        remark: data.data.local.remark ? data.data.local.remark : '暂无备注',

      };
      if(data.data.local.type !== '0'){
          afterObj.sceneFlag = this.dicDisplayScene[data.data.local.type][data.data.local.sceneFlag]
        }else {
          afterObj.sceneFlag = ''
        }
      this.afterUpdate = afterObj;
        } catch (error) {
          console.log(error);
        }
      } else {
        this.beforeUpdate = {};
      }
      // this.beforeUpdate = beforeObj;
      console.log("修改前的数据", this.beforeUpdate);
      console.log("修改后的数据", this.afterUpdate);
      this.auditDialog = true;
      this.showAuditOpinion = true;
    },
    /** 删除事件 */
    handleDel(id) {
      /** 二次询问用户 */
      this.$confirm("是否确认删除该会员权益项?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          console.log("删除事件传递给接口的id", id);
          const { data } = await deleteMemberTypeLocal(id);
          console.log("删除接口的响应", data);
          /** 如果成功提示用户 */
          if (data.code === 200) {
            Message.success("删除成功");
            /** 更新数据 */
            this.$emit("updateData");
          } else {
            Message.error("删除失败");
          }
        })
        .catch(() => {
            /** 更新数据 */
            this.$emit("updateData");
          // Message.info("已取消删除");
        });
    },
    //^ ^--------------////^ ^--------------获取初始数据-------------^ ^-------------^ ^
    /** 获取字典里的限制参数(备注) */
    async getRemark() {
      const { data: res } = await getMemberRightLocalLimitParams();
      console.log('获取字典里的限制参数(备注)', res.data);
      this.limitParams = res.data;
    },
    /** 获取字典里的会员类型 */
    async getMemberType() {
      const { data } = await getMemberType();
      /** 处理数据 */
      this.type = data.data.records.map((item) => {
        return {
          value: item.dictKey,
          label: item.dictValue,
        }
      })
      console.log('获取字典里的会员类型', this.type);
    },
    /** 获取字典里的用户身份 */
    async getUserIdentity() {
      const { data } = await getUserIdentity();
      /** 处理数据 */
      this.dicMemberIdentity = data.data.records.map((item) => {
        return {
          value: item.dictKey,
          label: item.dictValue,
        }
      })
      console.log('获取字典里的用户身份', this.dicMemberIdentity);
    },
    /** 获取字典里的客户端类型 */
    async getDictClient() {
      const { data } = await getMemberRightLocalList()
      this.dictClient = data.data
      console.log('获取字典里的客户端类型', this.dictClient);
    }
  },
};
</script>

<style lang="scss" scoped>
.overflow-ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>

<style lang="scss">
.el-tooltip__popper {
  max-width: 80% !important;
}
</style>